import request from '@/plugin/axios';

//	获取留言列表
export function GetMessage (data) {
  return request({
    url: request.adornUrl(
      '/message-board/get-message'
    ),
    method: 'post',
    data
  });
}

//	显示/不显示审核接口
export function Update (params) {
  return request({
    url: request.adornUrl(
      '/message-board/update'
    ),
    method: 'get',
    params
  });
}
